import type { Site } from 'src/biz_spa/types'

type SiteWithEnabled = {
  siteType: Site['siteType']
  isDisabled: boolean
}

type Props = {
  sites: SiteWithEnabled[]
  storeGmbConnected: boolean
}

export const formatProps = ({ sites, storeGmbConnected }: Props) => {
  const unconnectedSites = sites
    .filter((site) => (site.siteType === 'google' && !storeGmbConnected) || site.isDisabled)
    .map(v => v.siteType)
  const connectedSites = sites
    .filter((site) => (site.siteType === 'google' && storeGmbConnected) || !site.isDisabled)
    .map(v => v.siteType)

  return {
    unconnectedSites,
    connectedSites,
  }
}
